import { useEffect, useState } from "react";
import { Container, Spinner, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setLoading,
  setUserName,
  setUserRole,
  setUserId,
} from "../../redux/actions";
import api from "../../common/api";

export default function Bootstrap() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    let timer;
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setError("No access token found. This link may be invalid or expired.");
      console.error("Token not found in URL.");
      return;
    }

    sessionStorage.setItem("token", token);
    window.history.replaceState({}, "", "/auth/bootstrap");

    const fetchAndRedirect = async () => {
      try {
        const { data } = await api.get("/profile");
        console.log("Profile Data:", data);
        sessionStorage.setItem("name", data?.name || "");
        sessionStorage.setItem("email", data?.email || "");
        sessionStorage.setItem("userRole", "1");
        sessionStorage.setItem("userId", data?.user_id ?? data?.id ?? "");
        if (data?.company_id) {
          sessionStorage.setItem("companyId", data.company_id);
        }
        if (data?.stamping_partner_id) {
          sessionStorage.setItem("stampingPartnerId", data.stamping_partner_id);
        }
        dispatch(setUserRole(1));
        dispatch(setUserName(sessionStorage.getItem("name")));
        dispatch(setUserId(parseInt(sessionStorage.getItem("userId"))));
      } catch (err) {
        console.error("Error fetching user profile:", err);
        setError(
          "We couldn't load your profile. Don't worry, your workspace is ready!",
        );
      } finally {
        timer = setTimeout(() => {
          navigate("/dashboard", { replace: true });
        }, 3000);
      }
    };
    fetchAndRedirect();
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container
      fluid
      className="vh-100 d-flex justify-content-center align-items-center"
    >
      <div className="text-center">
        <Spinner
          animation="border"
          variant="primary"
          style={{
            width: "8rem",
            height: "8rem",
            color: "#531db0",
          }}
        />

        <h2 className="fw-bold mt-4 fs-1">
          welcome to <span style={{ color: "#531db0" }}>ReyZap</span> solar
          workspace
        </h2>
        <small className="text-secondary fs-5">
          This may take few seconds.
        </small>
        {error && (
          <p className="mt-3" style={{ color: "#e11d48", fontSize: "0.9rem" }}>
            ⚠️ {error}
          </p>
        )}
      </div>
    </Container>
  );
}
